import React from "react";

export default function End() {
  return (
    <>
      <img className="end" src={`svg/stop.svg`} alt="" />
    </>
  );
}
